export default __webpack_public_path__ + "static/media/coloredTiktokIcon.49b1a7fd.png";